"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _AppBreadcrumb = _interopRequireDefault(require("../../components/layout-components/AppBreadcrumb"));

var _IntlMessage = _interopRequireDefault(require("../util-components/IntlMessage"));

var PageHeader = function PageHeader(_ref) {
  var title = _ref.title,
      display = _ref.display;
  return display ? /*#__PURE__*/_react.default.createElement("div", {
    className: "app-page-header"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "mb-0 mr-3 font-weight-semibold"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessage.default, {
    id: title ? title : 'home'
  })), /*#__PURE__*/_react.default.createElement(_AppBreadcrumb.default, null)) : null;
};

exports.PageHeader = PageHeader;
var _default = PageHeader;
exports.default = _default;